'use client';
import { jsx } from 'react/jsx-runtime';

function BarLabel({
  value,
  valueFormatter,
  textBreakAll,
  parentViewBox,
  orientation,
  viewBox,
  width,
  height,
  ...others
}) {
  return /* @__PURE__ */ jsx(
    "text",
    {
      ...others,
      dy: orientation === "vertical" ? height / 2 + 4 : -10,
      dx: orientation === "vertical" ? width - 30 : 0,
      fontSize: 12,
      fill: "var(--chart-bar-label-color, var(--mantine-color-dimmed))",
      children: typeof valueFormatter === "function" ? valueFormatter(value) : value
    }
  );
}

export { BarLabel };
//# sourceMappingURL=BarLabel.mjs.map
